// @mui icons
import Icon from "@mui/material/Icon";

// Pages
import UserProfile from "./user/profile";
import Dashboard from "./dashboard";
// import DispenseVoucher from "./transact/dispense";
// import OnboardCustomer from "./transact/onboard";
// import History from "./transact/history";
import SellProduct from "./transact/sell";
import Commissions from "./campaigns/commissions";
import Wallet from "./wallet";
import AffiliateLinks from "./campaigns/affiliate_links";
// import Campaigns from "./transact/campaigns";
import Orders from "./transact/orders";
import MyCampaigns from "./campaigns/my_campaigns";
// import TeleSalesCampaigns from "./telemarketing";
import Organisations from "./teams/organisations";
import Inbox from "./inbox";
import Courses from "./trainings/courses";
import CourseCertificates from "./trainings/certificates";
// import Gigs from "./gigs";
// import AgentWebStore from "./webstore";
// import PromoteIndex from "./social/promote";
// import Products from "./gigs/products";
import CheckInRequestsPage from "./check_ins";
import DataCollectionPage from "./transact/data_capture";
// import CampaignAttendancesPage from "./attendances";
import AttendancesPage from "./attendances";
import GPSCameraPage from "./tools/gps_camera";
import LeadBucketsPage from "./leads/buckets";
import DawActivationsPage from "./activations/daw";
import CampaignsIndexPage from "./campaigns";
import TasksPage from "./dashboard/tasks";
import CallCentersPage from "./call_center";
import VisitTrackerLocationsPage from "./visits/locations";
import VisitTrackersPage from "./visits/trackers";
import OpsAccountsPage from "./ops/accounts";
import InventoryAssignmentsPage from "./inventory";
// import SocialHomePage from "./social";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "call-centers",
    icon: <Icon fontSize="small">dialer_sip</Icon>,
    route: "/voice",
    component: <CallCentersPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Trainings",
    key: "courses",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/courses",
    component: <Courses />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Certificates",
    key: "courses/certificates",
    icon: <Icon fontSize="small">workspace_premium</Icon>,
    route: "/courses/certificates",
    component: <CourseCertificates />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Inbox",
    key: "messages",
    icon: <Icon fontSize="small">mail</Icon>,
    route: "/messages",
    component: <Inbox />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Wallet",
    key: "wallet",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/wallet",
    component: <Wallet />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <UserProfile />,
    secure: true,
  },
];

export default routes;
